const InboxMessageRoute = () => '';

export default InboxMessageRoute;
